import { useEffect } from 'react';
import { useNavigate, Link } from 'react-router';
import { Info } from 'lucide-react';

export default function VerifyEmailPage() {
  const navigate = useNavigate();

  // Old token-based links are no longer supported — redirect to check-email
  useEffect(() => {
    const email = sessionStorage.getItem('forgealpha_verify_email');
    if (email) {
      navigate('/check-email', { replace: true });
    }
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="w-full max-w-sm text-center">
        <div
          className="w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-6"
          style={{ background: 'rgba(249,115,22,0.1)', border: '1px solid rgba(249,115,22,0.2)' }}
        >
          <Info size={28} className="text-orange" />
        </div>
        <h1 className="text-xl font-extrabold mb-2">Use your verification code</h1>
        <p className="text-sm text-ink-3 mb-6 leading-relaxed">
          We now use 6-digit codes instead of email links. Check your inbox for a code and enter it on the verification page.
        </p>
        <Link
          to="/check-email"
          className="inline-block px-6 py-2.5 rounded-lg text-sm font-bold text-white"
          style={{ background: 'linear-gradient(135deg, #f97316, #f59e0b)' }}
        >
          Enter Code
        </Link>
        <div className="h-px bg-border my-6" />
        <Link to="/login" className="text-xs text-ink-3 hover:text-ink-2">
          Back to sign in
        </Link>
      </div>
    </div>
  );
}
